import styled from '@emotion/styled';
import { Field } from '@lbcamden/lib-react';

export const TextAreaField = styled(Field)`
  gap: ${({ theme }) => theme.spacing(3)};

  label {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;
